export default __webpack_public_path__ + "static/audio-cardio-5-a-3fdf368e37915985b28bbba194c20657.webp";